/**
 * ============================================================
 *  CENTRALIZED BUSINESS CONFIGURATION — CV ANGKASA BRILIANT
 * ============================================================
 *  Ubah informasi bisnis DI SATU TEMPAT INI SAJA.
 *  Perubahan otomatis berlaku di seluruh website.
 * ============================================================
 */

export const business = {
  companyName: "CV Angkasa Briliant",
  legalName: "CV Angkasa Briliant",
  tagline: "AC • HVAC • Electrical • Maintenance",

  // --- Brand layanan ---
  brand: {
    name: "SEJUKARA",
    parent: "CV Angkasa Briliant",
    descriptor: "Cooling & HVAC Solutions",
    tagline: "AC • HVAC • ELECTRICAL • MAINTENANCE",
    byline: "by CV ANGKASA BRILIANT",
  },
  description:
    "CV Angkasa Briliant menyediakan layanan preventive maintenance AC, maintenance HVAC, service AC dan kontrak maintenance untuk perusahaan, kantor, hotel dan gedung di Makassar.",

  // --- Kontak ---
  // WhatsApp: tampilan lokal & format internasional (untuk link wa.me)
  whatsapp: {
    display: "087777635597",
    international: "6287777635597",
  },
  // Nomor telepon (kosongkan jika belum ada — tombol telepon otomatis disembunyikan)
  phone: "",
  email: "cvangkasabriliant@gmail.com",

  // --- Lokasi ---
  address: "BTP Blok G No. 145, Makassar",
  city: "Makassar",
  region: "Sulawesi Selatan",
  country: "Indonesia",
  serviceArea: "Makassar & Sekitarnya",

  // --- Pesan WhatsApp default ---
  whatsappDefaultMessage:
    "Hallo CV Angkasa Briliant, saya ingin berkonsultasi mengenai layanan SEJUKARA (AC/HVAC/Electrical/Maintenance).",
  // Pesan WhatsApp per segmen
  whatsappMessages: {
    b2c: "Hallo CV Angkasa Briliant, saya ingin berkonsultasi mengenai layanan AC dari SEJUKARA.",
    b2b: "Hallo CV Angkasa Briliant, saya ingin berkonsultasi mengenai SEJUKARA untuk kebutuhan AC/HVAC/maintenance perusahaan kami.",
  },

  // --- CTA utama ---
  cta: {
    primary: "MINTA SURVEY & PENAWARAN",
    secondary: "WHATSAPP SEKARANG",
    navbar: "Minta Penawaran",
    serviceCard: "Konsultasikan Kebutuhan",
    residential: "BOOKING SERVICE",
    bookingService: "BOOKING SERVICE",
    requestMaintenance: "REQUEST MAINTENANCE",
    requestHvac: "REQUEST HVAC ASSESSMENT",
    requestAcAssessment: "REQUEST AC ASSESSMENT",
    requestContract: "REQUEST MAINTENANCE CONTRACT",
    form: "KIRIM PERMINTAAN PENAWARAN",
  },

  // --- Sosial media (kosongkan jika belum ada — otomatis disembunyikan) ---
  socialLinks: {
    instagram: "", // contoh: "https://instagram.com/cvangkasabriliant"
    tiktok: "", // contoh: "https://tiktok.com/@cvangkasabriliant"
    facebook: "",
    linkedin: "",
  },

  // --- SEO ---
  seo: {
    title: "SEJUKARA — AC, HVAC, Electrical & Maintenance Makassar | CV Angkasa Briliant",
    description:
      "SEJUKARA by CV Angkasa Briliant: layanan AC, HVAC, electrical, instalasi, service & repair, preventive maintenance dan kontrak maintenance untuk rumah, bisnis, dan fasilitas perusahaan di Makassar & sekitarnya.",
    keywords:
      "SEJUKARA, service AC Makassar, cuci AC Makassar, instalasi AC Makassar, maintenance AC Makassar, preventive maintenance AC Makassar, maintenance HVAC Makassar, kontrak maintenance AC, electrical Makassar, vendor HVAC Makassar",
    siteUrl: "https://sejukara.com",
  },
};

/**
 * Konfigurasi Analytics & Tracking.
 * Isi ID di file frontend/.env (lihat README) — jangan hardcode di sini.
 * Contoh env:
 *   REACT_APP_GA4_MEASUREMENT_ID=G-XXXXXXX
 *   REACT_APP_GTM_ID=GTM-XXXXXXX
 *   REACT_APP_GOOGLE_ADS_CONVERSION_ID=AW-XXXXXXXXX
 *   REACT_APP_GOOGLE_ADS_CONVERSION_LABEL=xxxxxxxxxxx
 */
export const tracking = {
  ga4MeasurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID || "",
  gtmId: process.env.REACT_APP_GTM_ID || "",
  googleAdsConversionId: process.env.REACT_APP_GOOGLE_ADS_CONVERSION_ID || "",
  googleAdsConversionLabel:
    process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL || "",
};

export default business;
